import { Stack } from '@mantine/core'
import { useState } from 'react'
import { ImportCameraData } from '@/types/camera'
import { Device } from '@/types/device'
import { CameraSelectionHandler } from './CameraSelectionHandler/CameraSelectionHandler'
import {
  ImportCompletionStatus,
  ImportProgressHandler
} from './ImportProgressHandler/ImportProgressHandler'
import { MilestoneHeader } from './MilestoneHeader/MilestoneHeader'
import { MilestoneUrlHandler } from './MilestoneUrlHandler/MilestoneUrlHandler'

type Step = 'url_validation' | 'camera_selection' | 'import_progress'

type MilestoneImportHandlerProps = {
  devices: Device[]
  onCompletion: (status: ImportCompletionStatus) => void
  onClose: () => void
}

export const MilestoneImportHandler = ({
  devices,
  onCompletion,
  onClose
}: MilestoneImportHandlerProps) => {
  const [step, setStep] = useState<Step>('url_validation')
  const [deviceId, setDeviceId] = useState<string | null>(null)
  const [cameras, setCameras] = useState<ImportCameraData[]>([])

  const handleCamerasFetched = (
    deviceId: string,
    cameras: ImportCameraData[]
  ) => {
    setDeviceId(deviceId)
    setCameras(cameras)
    setStep('camera_selection')
  }

  const handleImportStart = () => {
    setStep('import_progress')
  }

  return (
    <Stack gap="xl" mih={400}>
      <MilestoneHeader />

      {step === 'url_validation' && (
        <MilestoneUrlHandler
          devices={devices}
          onCamerasFetched={handleCamerasFetched}
        />
      )}

      {deviceId && step === 'camera_selection' && (
        <CameraSelectionHandler
          deviceId={deviceId}
          cameras={cameras}
          onImportStart={handleImportStart}
          onBack={() => setStep('url_validation')}
        />
      )}

      {deviceId && step === 'import_progress' && (
        <ImportProgressHandler
          deviceId={deviceId}
          onCompletion={onCompletion}
          onClose={onClose}
          onBack={() => setStep('url_validation')}
        />
      )}
    </Stack>
  )
}
